import { render, staticRenderFns } from "./CoreImage.vue?vue&type=template&id=6e180912&scoped=true&"
import script from "./CoreImage.vue?vue&type=script&lang=js&"
export * from "./CoreImage.vue?vue&type=script&lang=js&"
import style0 from "./CoreImage.vue?vue&type=style&index=0&id=6e180912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e180912",
  null
  
)

export default component.exports